// src/components/agent/CreditRequestList.js
// this code to see the agent orders credit form agent dashboard "button : View Order Requests"
import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

const CreditRequestList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRequests = async (uid) => {
      const q = query(
        collection(db, "creditRequests"),
        where("uid", "==", uid)
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setRequests(data);
      setLoading(false);
    };

    onAuthStateChanged(auth, (user) => {
      if (user) fetchRequests(user.uid);
    });
  }, []);

  if (loading) return <div>Loading requests...</div>;

  return (
    <div className="card p-3 mt-3">
      <h5>Credit Request History</h5>
      {requests.length === 0 ? (
        <p>No credit requests found.</p>
      ) : (
        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>Credits</th>
              <th>Amount</th>
              <th>Payment Type</th>
              <th>Status</th>
              <th>Requested At</th>
              <th>Approved At</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req, i) => (
              <tr key={i}>
                <td>{req.credits}</td>
                <td>{req.amount}</td>
                <td>{req.paymentType}</td>
                <td
                  style={{
                    color:
                      req.status === "approved"
                        ? "green"
                        : req.status === "rejected"
                        ? "red"
                        : "orange",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {req.status}
                </td>
                <td>{req.timestamp?.toDate().toLocaleString()}</td>
                <td>
                  {req.status === "approved"
                    ? req.approvedAt?.toDate().toLocaleString()
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CreditRequestList;
